exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab[data-v-a361ca92]{height:.95rem;line-height:.95rem}.flex-item[data-v-a361ca92]{height:100%;margin:0 1.02rem}.tab-active[data-v-a361ca92]{color:#0047ba;border-bottom:3px solid #0047ba;height:calc(100% - 3px)}.cont[data-v-a361ca92]{padding:.3rem .32rem}.cont textarea[data-v-a361ca92]{background:#f9f9f9;border:1px solid #e5e5e5;border-radius:.04rem;width:100%;padding:.2rem;box-sizing:border-box;resize:none;height:4.24rem}.btns[data-v-a361ca92]{position:fixed;bottom:.2rem;padding:0 .2rem;width:100%;box-sizing:border-box}.btn[data-v-a361ca92]{height:.9rem;line-height:.9rem;border-radius:.04rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a361ca92","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/my/proposal/proposal.vue
// module id = 335
// module chunks = 0